import { HttpStatusCode } from "@angular/common/http";
import {TableColumnType} from "../../../../common/interfaces/table.interface";

export interface Page {
  id?: number;
  totalElements?: number;
  totalPages?: number;
  size?: number;
  first?: boolean;
  last?: boolean;
  hasContent?: boolean;
  hasNext?: boolean;
  numberOfElements?: number;
  content?: any[];
}


export interface Pageable {
  first?: number;
  sortBy?: string;
  sortDirection?: string;
  size?: number;
}


export const INITIALIZED_PAGEABLE_PARAMETER = {
  first: 0,
  size: 10,
  sortBy: 'id',
  sortDirection: 'DESC',
  searchFields: []
};

export const INITIALIZED_PAGEABLE_PARAMETER_10k = {
  first: 0,
  size: 10000,
  sortBy: 'id',
  sortDirection: 'DESC',
};
export const INITIALIZED_PAGEABLE_PARAMETER_6 = {
  first: 0,
  size: 6,
  sortBy: 'id',
  sortDirection: 'DESC',
};


export enum QueryOperator {
  And = 'AND',
  Or = 'OR',
}

export interface SearchFieldsDtoInput {
  fieldName?: string;
  fieldValue?: any;
  fieldValues?: any[];
  searchType?:any;
  queryOperator?: QueryOperator;
}


export interface PageableParamInput {
  first?: number;
  size?: number;
  sortBy?: string;
  sortDirection?: string;
  searchFields?: SearchFieldsDtoInput[];
  searchCombinationType?: QueryOperator;
}

export interface ResponsePagination {
  totalElements?: number;
  totalPages?: number;
  hasContent: boolean;
}

export interface PageableResponse<T> {
  content?: T[];
  pagination?: ResponsePagination;
  size?: number;
  number?: number;
  first?: boolean;
  last?: boolean;
  totalElements?: number;
  totalPages?: number;
}

export interface PageResult {
  totalElements?: number;
  totalPages?: number;
  size?: number;
  last?: boolean;
  first?: boolean;
  number?: number;
  hasContent: boolean;
  content?: any[];
}

export interface NonPageResult {
  code?: any;
  data?: any;
  dataList?: any[];
  message?: string;
  fieldsErrors?: any;
  status?: boolean;
}








export const InitializedPageableParameter: PageableParamInput = {
  first: 0,
  size: 10,
  sortBy: 'id',
  sortDirection: 'DESC',
};



export interface InputSearchState {
  keys?: string[],
  value?: any;
}

export interface CurrentSort {
  sortBy?: string;
  sortDirection: ('DESC' | 'ASC');
}

export enum ApprovalAssignmentStatus {
  APPROVED = "APPROVED",
  ASSIGNED = "  ASSIGNED",
  DORMANT = "  DORMANT",
}

export interface ViewModel {
  viewRowData: ViewRowData[];
  flexDirection: 'row' | 'col';
  parentClass?: string;
  heading?: string;
  
}

interface ViewRowData {
  title: string;
  subTitle?: String | number | unknown;
  childClass?: string;
  hasRoute?: boolean;
  innerRoute?: any [];
  extRoute?: any [];
  dontShow?:boolean ;
  type?: TableColumnType;
  theme?:string;
}
